/**
 * CeoDashboardPage — `/ceo`.
 *
 * This legacy route redirects to `/omega/ceo` where the real CEO GI
 * dashboard lives (OmegaCeoDashboardPage, Phase 36.7a).
 */

import { Navigate } from 'react-router-dom';

export function CeoDashboardPage() {
  return <Navigate to="/omega/ceo" replace />;
}
